module.exports = __webpack_public_path__ + "img/g3.9cfa2f92.png";